// extracted by mini-css-extract-plugin
export default {"searchContainer":"styles_searchContainer__D3VR-"};